import Repository from "./Repository";
const resource = "/api/v1/users/";
const resource2 = "/api/v1/extra/";
export default {
  postUsers(data) {
    let subUrl = `${resource}signup`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
  loginUsers(data) {
    let subUrl = `${resource}login`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
  getUsersInfo() {
    let subUrl = `${resource}ownprofile`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getUserPlan() {
    let subUrl = `${resource2}get-plan`;
    return Repository.sendReq("get", subUrl, null);
  },
  logoutUser(data) {
    let subUrl = `${resource}ForceLogout`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
};
